import classNames from "classnames";
import PropTypes from "prop-types";
import {formatPaymentMethodBrand} from "./payment-method-utils";

const formatExpiry = (method) => {
    if (!method?.expiryMonth || !method?.expiryYear) return null;
    return `${String(method.expiryMonth).padStart(2, "0")}/${String(method.expiryYear).slice(-2)}`;
};

export const PaymentCardIcon = ({className}) => (
    <span
        className={classNames("flex h-8 w-8 shrink-0 items-center justify-center text-gray-500", className)}
        aria-hidden="true"
    >
        <svg width="20" height="14" viewBox="0 0 20 14" fill="none">
            <rect x=".75" y=".75" width="18.5" height="12.5" rx="2.25" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M1.5 4.75h17M4.5 9.5h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    </span>
);

PaymentCardIcon.propTypes = {
    className: PropTypes.string
};

PaymentCardIcon.defaultProps = {
    className: ""
};

export default function SavedPaymentMethodSummary({method, description, className}) {
    const expiry = formatExpiry(method);

    return (
        <span className={classNames("flex min-w-0 items-start gap-3", className)}>
            <PaymentCardIcon/>
            <span className="min-w-0 grow">
                <span className="block text-sm font-semibold text-gray-900">
                    <span>{formatPaymentMethodBrand(method?.brand)}</span>
                    <span className="ml-1 font-normal text-gray-600">•••• {method?.lastFour || "••••"}</span>
                </span>
                {expiry ? (
                    <span className="mt-0.5 block text-xs text-gray-600">Expires {expiry}</span>
                ) : null}
                {description ? (
                    <span className="mt-1 block text-sm text-gray-700">{description}</span>
                ) : null}
            </span>
        </span>
    );
}

SavedPaymentMethodSummary.propTypes = {
    method: PropTypes.shape({
        brand: PropTypes.string,
        lastFour: PropTypes.string,
        expiryMonth: PropTypes.number,
        expiryYear: PropTypes.number
    }).isRequired,
    description: PropTypes.node,
    className: PropTypes.string
};

SavedPaymentMethodSummary.defaultProps = {
    description: null,
    className: ""
};
